<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ResourceEditorFormSubmitEventPayload, ResourceEditorViewModel } from '@Quest/Resources/Components/ResourceEditor';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ResourceEditor extends Vue
    {
        get vm(): ResourceEditorViewModel { return this.$props.viewModel as ResourceEditorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get confirmButtonLabel(): string { return this.vm.confirmButtonLabel; }
        get modalTitle(): string { return this.vm.modalTitle; }
        get costPerUnitVisible(): boolean { return this.vm.costPerUnitVisible; }

        get name(): string { return this.vm.name; }
        set name(val: string) { this.vm.name = val; }

        get unit(): string { return this.vm.unit; }
        set unit(val: string) { this.vm.unit = val; }

        get classification(): string { return this.vm.classification; }
        set classification(val: string) { this.vm.classification = val; }

        get costPerUnit(): number | null { return this.vm.costPerUnit; }
        set costPerUnit(val: number | null) { this.vm.costPerUnit = val; }

        handleFormSubmit()
        {
            const payload = new ResourceEditorFormSubmitEventPayload(this.vm.id, this.name, this.unit, this.classification, this.costPerUnit);
            this.$emit('form-submit', payload);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="resource-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input type="text" v-model.trim="name" class="form-control" required minlength="2" maxlength="100" />
                            </div>
                            <div class="form-group">
                                <label>Unit:</label>
                                <input type="text" v-model.trim="unit" class="form-control" maxlength="50" />
                            </div>
                            <div class="form-group">
                                <label>P&L cost classification:</label>
                                <select class="form-control" v-model="classification">
                                    <option value="OpEx">OpEx</option>
                                    <option value="COGS">COGS</option>
                                    <option value="Other">Other expenses</option>
                                    <option value="None">None</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="costPerUnitVisible">
                                <label>Cost per unit:</label>
                                <input type="number" v-model.number="costPerUnit" class="form-control" min="0" step="any" />
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="resource-editor-form" class="btn btn-primary">{{ confirmButtonLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>